import { ENTITY_TYPE as ENTITY_TYPES } from 'modules/file/constants';

export const DEFAULT_AVATAR =
  'https://static.club.hotmart.com/images/comment_default_avatar.png';

export const ENTITY_TYPE = ENTITY_TYPES.PERSONA_IMG;
